import React, { useState } from 'react';
import { MenuProps } from '../layouts/sharedLayout';
import { MenuStyles } from '../assets/css/menu.styles';
import * as MuiIcons from '@mui/icons-material'; 

interface NavbarProps {
  menuData: MenuProps[];
}

const Navbar: React.FC<NavbarProps> = ({ menuData }) => {
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);
  const [hoveredSubmenuItem, setHoveredSubmenuItem] = useState<string | null>(null);

  const handleItemHover = (section: string) => setHoveredItem(section);
  const handleItemLeave = () => setHoveredItem(null);
  const handleSubmenuItemHover = (itemName: string) => setHoveredSubmenuItem(itemName);
  const handleSubmenuItemLeave = () => setHoveredSubmenuItem(null);

  const renderIcon = (iconName: string) => {
    const IconComponent = MuiIcons[iconName as keyof typeof MuiIcons];
    return IconComponent ? <IconComponent style={{ marginRight: '10px'}} /> : null;
  };

  return (
    <nav style={MenuStyles.navbar}>
      <ul style={{ ...MenuStyles.navbarNav, display: 'flex', justifyContent: 'space-between' }}>
        {menuData.map((section, index) => (
          <li
            style={{
              ...MenuStyles.navItem,
              ...(section.section === 'User Management' ? { marginLeft: 'auto', marginRight: '30px' } : {}),
            }}
            key={index}
            onMouseEnter={() => handleItemHover(section.section)}
            onMouseLeave={handleItemLeave}
          >
            <a style={MenuStyles.navLink} href="#">
              {section.section}
            </a>
            <ul
              style={{
                ...MenuStyles.submenu,
                ...(section.section === 'User Management' ? { minWidth: '150px' } : { minWidth: '200px' }),
                display: hoveredItem === section.section ? 'block' : 'none',
              }}
            >
              {section.permissions.map((item, idx) => (
                <li
                  style={{
                    ...MenuStyles.submenuItem,
                    ...(hoveredSubmenuItem === item.name ? MenuStyles.submenuItemHover : {}),
                  }}
                  key={idx}
                  onMouseEnter={() => handleSubmenuItemHover(item.name)}
                  onMouseLeave={handleSubmenuItemLeave}
                >
                  <a style={{ ...MenuStyles.submenuLink, display: 'flex', alignItems: 'center' }} href={item.pages.page}>
                      {renderIcon(item.icon)}
                      <span style={{ marginBottom: 0 }}>{item.name}</span>
                  </a> 
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navbar;
